import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";

const AppConfigContext = createContext();

export const useAppConfig = () => useContext(AppConfigContext);

const AppConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const { data } = await api.get("/config/app");
        setConfig(data);
      } catch (err) {
        console.error("Failed to fetch app config:", err);
        setError("Failed to load configuration.");
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return (
    <AppConfigContext.Provider value={{ config, loading, error }}>
      {children}
    </AppConfigContext.Provider>
  );
};

export default AppConfigProvider;
